import React, { Fragment } from 'react';
import Upload from './Upload';
import Requirements from './Requirements';
import license from '../../images/license.jpeg';

const good = ['21+ years old', 'Must be a full G license or higher', 'Must be from Ontario'];
const bad = ['Temporary license not accepted', 'Ontario G1 and G2 not accepted', 'International license not accepted'];
const description = "Please provide a picture of the front of your drivers's license.";

const DriversLicense = props => (
  <Fragment>
    <h2 className="upload-header">Driver's License</h2>

    {props.driversLicenseImage ? null : (
      <Requirements good={good} bad={bad} description={description}>
        <div className="license-container">
          <img className="license" src={license} alt="Driver's License" />
        </div>
      </Requirements>
    )}

    <Upload {...props} />
  </Fragment>
);

export default DriversLicense;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/DriversLicense.js